import { Text } from "@ttc3k/trekker";
import { NoteCard } from "shared/components";
import { Flex } from "styled-system/jsx";
import { useTranslation } from "react-i18next";
import type { OperatorTimelineItem } from "./useOperatorNotesTimeline";

type StaffNoteRowProps = {
  item: OperatorTimelineItem;
  suggestionsPortalHost?: HTMLElement | null;
};

export const StaffNoteRow = ({ item, suggestionsPortalHost }: StaffNoteRowProps) => {
  const { t } = useTranslation("directory", {
    keyPrefix: "OPERATOR.FLYOUT.TIMELINE",
  });

  if (!item.note) return null;

  return (
    <Flex flexDir="column" gap="50">
      {item.staffPersonName && (
        <Text visual="smallRegular" color="text.light">
          {t("STAFF_NOTE_VIA", { name: item.staffPersonName })}
        </Text>
      )}
      <NoteCard
        initialMode="view"
        note={item.note}
        suggestionsPortalHost={suggestionsPortalHost}
      />
    </Flex>
  );
};
